import { APIModel } from '@shared/interfaces';

import { PlatformSync } from './platform-sync.enum';
import { Platform } from './platform.model';

export class Connection implements APIModel {
    id: number = -1;
    name = '';
    platform = new Platform();
    externalEntityId?: number;
    email?: string;
    validUntil?: Date;
    shouldReauthorize = false;
    syncUsers = PlatformSync.NONE;
    redirectUrl?: string;
    username?: string;
    password?: string;
    otpCode?: string;
    apiKey?: string;
    apiKeyName?: string;

    deserialize(data: any): this {
        this.id = data.id;
        this.name = data.name ?? '';
        this.platform = data.platform ? new Platform().deserialize(data.platform) : new Platform();
        this.externalEntityId = data.external_entity_id ?? undefined;
        this.email = data.email ?? undefined;
        this.validUntil = data.valid_until ? new Date(data.valid_until) : undefined;
        this.shouldReauthorize = data.should_reauthorize ?? false;
        this.syncUsers = data.sync_users ?? PlatformSync.NONE;
        this.redirectUrl = data.redirect_url ?? undefined;
        this.username = data.username ?? undefined;
        this.password = data.password ?? undefined;
        this.otpCode = data.otp_code ?? undefined;
        this.apiKey = data.api_key ?? undefined;
        this.apiKeyName = data.api_key_name ?? undefined;
        return this;
    }

    serialize(): any {
        return {
            platform_id: this.platform.id,
            external_entity_id: this.externalEntityId,
            sync_users: this.syncUsers,
            redirect_url: this.redirectUrl,
            username: this.username,
            password: this.password,
            otp_code: this.otpCode,
            api_key: this.apiKey,
            api_key_name: this.apiKeyName,
        };
    }

    static Sort(c1: Connection, c2: Connection): number {
        const platformSort = Platform.Sort(c1.platform, c2.platform);
        return platformSort != 0 ? platformSort : c1.name.localeCompare(c2.name);
    }
}
